export default class Calendar {
    static init() {
        this.elt = document.querySelector('.calendrier');
        if(!this.elt) {
            return false;
        }

        this.DAYSNAMES = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
        this.MONTHSNAMES = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

        this.displayPopin();
        this.displayDetail();
        this.displayHourEvent();
    }

    static displayPopin() {
        const events = this.elt.querySelectorAll('.calendrier__detailItem');
        if(events.length > 0) {
            events.forEach((event) => {
                // Ouverture de la popin de détail.
                event.addEventListener('click', () => {
                    document.querySelector('.calendrier__detail--visible').classList.add('js-popinOpen');
                    this.displayEvent(event);
                });
            });
        }
    }

    static displayDetail() {
        const days = document.querySelectorAll('.calendrier__item--filled');
        if(days.length > 0) {
            days.forEach((day) => {
                day.addEventListener('click', () => {
                    if (day.classList.contains('calendrier__item--disabled')) {
                        return false;
                    }
                    
                    // Si le jour cliqué est différent du jour actif.
                    if(this.elt.querySelector('.calendrier__item--selected') !== day) {
                        // Fermeture de la popin ouvert s'il y en a une.
                        if(this.elt.querySelector('.calendrier__detail.js-popinOpen')) {
                            this.elt.querySelector('.calendrier__detail.js-popinOpen').classList.remove('js-popinOpen');
                        }

                        // Suppression du jour sélectionné s'il y en a un.
                        if(this.elt.querySelector('.calendrier__item--selected')) {
                            this.elt.querySelector('.calendrier__item--selected').classList.remove('calendrier__item--selected');
                        }

                        // Sélection du jour dans le calendrier.
                        day.classList.add('calendrier__item--selected');

                        const d = new Date(day.dataset.dayname);
                        const dDate = this.DAYSNAMES[d.getDay()];
                        const dDay = d.getDate().toString();
                        const dMonth = this.MONTHSNAMES[d.getMonth()];
                        const dYear = d.getFullYear().toString();

                        if(this.elt.querySelector(`[data-jour="${day.dataset.day}"] .calendrier__subtitle .calendrier__currentDay`)) {
                            this.elt.querySelector(`[data-jour="${day.dataset.day}"] .calendrier__subtitle .calendrier__currentDay`).innerText = `${dDate} ${dDay} ${dMonth} ${dYear}`;
                        }
                        if(this.elt.querySelector(`[data-jour="${day.dataset.day}"] .calendrier__detailPopin .calendrier__subtitle`)) {
                            this.elt.querySelector(`[data-jour="${day.dataset.day}"] .calendrier__detailPopin .calendrier__subtitle`).innerText = `${dDate} ${dDay} ${dMonth} ${dYear}`;
                        }

                        // Affichage du détail des évènements dans le panel de droite si le contenu existe.
                        if(this.elt.querySelector(`[data-jour="${day.dataset.day}"]`)) {
                            if(this.elt.querySelector('.calendrier__detail.calendrier__detail--visible')) {
                                this.elt.querySelector('.calendrier__detail.calendrier__detail--visible').classList.remove('calendrier__detail--visible');
                            }
                            this.elt.querySelector(`[data-jour="${day.dataset.day}"]`).classList.add('calendrier__detail--visible');
                        }
                    }
                });
            });
        }
    }

    static displayHourEvent() {
        const elts = document.querySelectorAll('.calendrier__dateItem');
        if(elts.length > 0) {
            elts.forEach((elt) => {
                elt.addEventListener('click', () => {
                    this.displayEvent(elt);
                });
            });
        }
    }
    
    static displayEvent(event) {
        console.log(event);
        // Affichage de l'évènement cliqué si ce n'est pas celui déjà affiché par défaut.
        if(!this.elt.querySelector(`.calendrier__detail.js-popinOpen .calendrier__hourContent[data-id="${event.dataset.target}"]`).classList.contains('calendrier__hourContent--visible')) {
            if(this.elt.querySelector('.calendrier__dateItem--selected')) {
                this.elt.querySelector('.calendrier__dateItem--selected').classList.remove('calendrier__dateItem--selected');
            }
            if(this.elt.querySelector(`.calendrier__dateItem[data-target="${event.dataset.target}"]`)) {
                event.parentElement.parentElement.querySelector(`.calendrier__detailPopin .calendrier__dateItem[data-target="${event.dataset.target}"]`).classList.add('calendrier__dateItem--selected');
            }
            if (this.elt.querySelector(`.calendrier__detail.js-popinOpen .calendrier__hourContent.calendrier__hourContent--visible`)) {
                this.elt.querySelector(`.calendrier__detail.js-popinOpen .calendrier__hourContent.calendrier__hourContent--visible`).classList.remove('calendrier__hourContent--visible');
            }
            this.elt.querySelector(`.calendrier__detail.js-popinOpen .calendrier__hourContent[data-id="${event.dataset.target}"]`).classList.add('calendrier__hourContent--visible');
        }
    }
}